import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function CashRunwayVisual({ title, takeaway, caption, data = {} }) {
  const cash = data.cash ?? 12;
  const annualBurn = data.annualBurn ?? 8;
  const runwayMonths = data.runwayMonths ?? Math.round((cash / annualBurn) * 12);
  const milestoneMonth = data.milestoneMonth ?? Math.max(1, runwayMonths - 4);
  const milestoneX = 110 + Math.min(milestoneMonth / runwayMonths, 1) * 520;

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption}>
      <svg viewBox="0 0 760 286" role="img" aria-label={`Example showing ${cash} million dollars of cash divided by ${annualBurn} million dollars of annual spending, resulting in an estimated ${runwayMonths} months of runway, with a project milestone occurring before the runway ends.`}>
        <rect x="24" y="24" width="180" height="88" rx="8" fill={p.surface} stroke={p.line} />
        <text x="114" y="56" textAnchor="middle" fontSize="13" fontWeight="800" fill={p.muted}>Available Cash</text>
        <text x="114" y="88" textAnchor="middle" fontSize="28" fontWeight="900" fill={p.ink}>${cash}M</text>

        <text x="236" y="78" textAnchor="middle" fontSize="30" fontWeight="900" fill={p.gold}>÷</text>

        <rect x="268" y="24" width="180" height="88" rx="8" fill={p.surface} stroke={p.line} />
        <text x="358" y="56" textAnchor="middle" fontSize="13" fontWeight="800" fill={p.muted}>Annual Cash Outflow</text>
        <text x="358" y="88" textAnchor="middle" fontSize="28" fontWeight="900" fill={p.ink}>${annualBurn}M</text>

        <path d="M468 68 H545" stroke={p.gold} strokeWidth="3" />
        <path d="M545 68 l-10 -7 v14 z" fill={p.gold} />

        <rect x="566" y="24" width="170" height="88" rx="8" fill={p.goldWash} stroke={p.gold} />
        <text x="651" y="56" textAnchor="middle" fontSize="13" fontWeight="800" fill={p.muted}>Estimated Runway</text>
        <text x="651" y="88" textAnchor="middle" fontSize="28" fontWeight="900" fill={p.ink}>{runwayMonths} months</text>

        <line x1="110" y1="208" x2="650" y2="208" stroke={p.ink} strokeWidth="2" />
        <path d="M650 208 l-12 -7 v14 z" fill={p.ink} />
        <line x1="110" y1="196" x2="110" y2="220" stroke={p.ink} strokeWidth="2" />
        <text x="110" y="244" textAnchor="middle" fontSize="13" fontWeight="800" fill={p.muted}>Today</text>
        <text x="650" y="244" textAnchor="middle" fontSize="13" fontWeight="800" fill={p.muted}>{runwayMonths} months</text>

        <line x1={milestoneX} y1="156" x2={milestoneX} y2="220" stroke={p.gold} strokeWidth="2" strokeDasharray="5 5" />
        <path d={`M${milestoneX} 146 l9 9 l-9 9 l-9 -9 z`} fill={p.gold} />
        <text x={milestoneX} y="132" textAnchor="middle" fontSize="13" fontWeight="850" fill={p.ink}>Next milestone · Month {milestoneMonth}</text>
      </svg>
    </LearnVisualFrame>
  );
}
